<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_PATRIMONY_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.patrimony;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.loading = true;
        this.$emit("entry-created", this.entry);
        this.loading = false;
        this.$refs.baseNew.closeDialog();
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_PATRIMONY_QUERY = gql `
  {
    accountContext {
      patrimony {
        id
        patrimonyCategoryId
        brandId
        description
        chassi
        tare
        loadCapacity
        hourlyPrice
        model
        plate
        year
        price
        plateStateId
        validations
      }
    }
    globalContext {
      allPatrimonyCategories {
        id
        name
      }
      allStates {
        id
        name
        shortName
      }
      allWheeledTypes
      allBodyTypes
    }
    accountGlobalSharedContext {
      allPatrimonyBrands {
        id
        name
      }
    }
  }
`;

</script>

<style scoped></style>

<!--
  createPatrimony(
  	input: {
      description: "desc",
      chassi: "chassi",
      hourlyPrice: 50,
      model: "model",
      plate: "plate",
      price: 50,
      brandId: 10,
      patrimonyCategoryId: 1,
      year: 2020
  }) {
    patrimony {
      id
    }
    errors
  }
 -->
